module.exports = __webpack_public_path__ + "static/img/notlink_summary_button.253781e7.png";